<template>
  <div class="h-screen flex w-full bg-img" id="page-login">
    <div class="vx-col sm:w-1/3 m-auto self-center login-page full-page">
      <div class="vx-row m-auto">
        <div class="vx-col w-full">
          <h1 align="center" class="my-4">{{ $t("labels.iqcrm") }}</h1>
          <div class="vx-row justify-center flex">
            <div class="vx-col w-full">
              <vx-card class="login-card">
                <div class="vx-card__title mb-5">
                  <h2 align="center">
                    {{ forcePasswordChange ? 'Change Password' : $t("labels.login") }}
                  </h2>
                  <p class="pt-4 text-primary" align="center">
                    {{
                      forcePasswordChange
                        ? 'Please update your password to continue'
                        : $t("strings.login_account")
                    }}
                  </p>
                </div>

                <!-- Login Form -->
                <form v-if="!forcePasswordChange" @submit.prevent="checkValidation()" autocomplete="off">
                  <vs-input name="email" :label="$t('labels.email')" icon-no-border icon="icon icon-user"
                    icon-pack="feather" v-model="email" class="w-full" v-validate="'required|email'" />
                  <span class="text-danger text-sm">{{ errors.first("email") }}</span>

                  <vs-input name="password" :label="$t('labels.password')" icon-no-border icon="icon icon-lock"
                    icon-pack="feather" v-model="password" class="w-full mt-6" v-validate="'required'"
                    id="login-form-password" :type="show_password === false ? 'password' : 'text'" />
                  <span class="text-danger text-sm">{{ errors.first("password") }}</span>

                  <div class="position">
                    <svg id="Layer_1" @click="togglePass()" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                      fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                      <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                      <path
                        d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                      <title>view password</title>
                    </svg>
                    <svg id="Layer_2" @click="togglePass()" style="display: none" xmlns="http://www.w3.org/2000/svg"
                      width="20" height="20" fill="currentColor" class="bi bi-eye-slash-fill" viewBox="0 0 16 16">
                      <path
                        d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588z" />
                      <path
                        d="M5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z" />
                      <path
                        d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z" />
                      <title>Hide password</title>
                    </svg>
                  </div>

                  <div class="my-5 login-btn" align="center">
                    <vs-button :disabled="button_loading" id="user-login" button="submit"
                      class="px-8 md:w-auto vs-button-primary vs-button-filled">
                      {{ $t("labels.login_button") }}
                    </vs-button>
                  </div>

                  <div class="mb-3 mt-5 forgot-pass" align="center">
                    <router-link :to="{ name: 'ForgotPassword' }">
                      {{ $t("labels.forget_password") }}
                    </router-link>
                  </div>
                </form>

                <!-- Force Password Change Form -->
                <form v-if="forcePasswordChange" @submit.prevent="submitNewPassword" autocomplete="off">
                  <!-- New Password Field -->
                  <vs-input v-model="newPassword" name="new_password" icon-no-border icon="icon icon-lock"
                    :type="show_password === false ? 'password' : 'text'" label="New Password" class="w-full mt-6"
                    icon-pack="feather" />
                  <span class="text-danger text-sm">{{ errors.first('new_password') }}</span>

                  <!-- Confirm Password Field -->
                  <vs-input v-model="confirmPassword" name="confirm_password" icon-no-border icon="icon icon-lock"
                    :type="show_password === false ? 'password' : 'text'" label="Confirm Password" class="w-full mt-6"
                    icon-pack="feather" />
                  <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>


                  <div class="my-5 login-btn" align="center">
                    <vs-button :disabled="button_loading" @click="submitNewPassword">
                      Update Password & Continue
                    </vs-button>
                  </div>
                </form>
              </vx-card>

              <div class="login-footer md:flex my-6" align="center">
                <a class="md:pr-6">{{ $t("labels.privacy") }}</a>
                <a class="md:pl-6">{{ $t("labels.terms") }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createHelpers } from "vuex-map-fields";
const { mapFields } = createHelpers({
  getterType: "getLoginField",
  mutationType: "updateLoginField",
});
export default {
  data() {
    return {
      show_password: false,
      isPassVisible: false,
      forcePasswordChange: false,
      newPassword: "",
      confirmPassword: "",
      showPassword: false,
    };
  },
  computed: {
    ...mapFields(["email", "password"]),
  },
  mounted() {
    this.setValidationMessage();
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then((result) => {
        if (result) this.login();
      });
    },
    async login() {
      const input = {
        email: this.email,
        password: this.password,
      };
      const response = await this.getHTTPPostResponse(
        "/login",
        input,
        "#user-login"
      );
      if (response) {
        const data = response.data;
        const token = data.token;

        // Store token if force password change
        if (data.force_password_change) {
          this.forcePasswordChange = true;
          localStorage.setItem("authToken", token);
          this.$store.dispatch("updateAuthToken", token);
          return;
        }

        this.handleLoginSuccess(data, token);
      }
    },
    handleLoginSuccess(data, token) {
      localStorage.setItem("authToken", token);
      this.$store.dispatch("updateAuthToken", token);

      const user = data.user;
      const userInfo = {
        name: user.name,
        email: user.email,
        organisation_name: user.organisation_name,
        type: user.type,
        subtype: user.sub_type,
        role_id: user.role_id,
        id: user.id,
        type_name: user.type_name,
      };
      localStorage.setItem("user", JSON.stringify(userInfo));
      this.$store.dispatch("updateUser", userInfo);

      if (user.type === "A" || user.type === "CL") {
        this.$router.push({ name: "Dashboard" });
      } else {
        this.$router.push("/vessels");
      }
    },
    async submitNewPassword() {
      // Reset errors
      this.errors.newPassword = null;
      this.errors.confirmPassword = null;

      // Manual validation
      if (!this.newPassword) {
        this.errors.newPassword = "New password is required.";
      }

      if (!this.confirmPassword) {
        this.errors.confirmPassword = "Confirm password is required.";
      }

      if (this.newPassword && this.confirmPassword && this.newPassword !== this.confirmPassword) {
        this.errors.confirmPassword = "Passwords do not match.";
      }

      // If any errors exist, stop the process
      if (this.errors.newPassword || this.errors.confirmPassword) {
        this.$vs.notify({
          title: "Error",
          text: "Please fix validation errors.",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      const payload = {
        password: this.newPassword,
        password_confirmation: this.confirmPassword,
      };

      const response = await this.getHTTPPostResponse(
        "/force-password-change",
        payload
      );
      if (response && response.data && response.data.user) {
        this.$vs.notify({
          title: "Success",
          text: "Password updated successfully.",
          color: "success",
          position: "top-right",
        });
        const token = localStorage.getItem("authToken");
        this.handleLoginSuccess(response.data, token);
      }

    },
    togglePass() {
      const x = document.getElementById("login-form-password");
      const s = document.getElementById("Layer_1");
      const h = document.getElementById("Layer_2");
      if (x.type === "password") {
        x.type = "text";
        s.style.display = "none";
        h.style.display = "inline";
      } else {
        x.type = "password";
        s.style.display = "inline";
        h.style.display = "none";
      }
    },
    destroyed() {
      this.$store.commit("clearPasswordField", null, { module: "login" });
    },
  },
};
</script>
<style scoped>
.vx-card__title h4 {
  font-weight: 600;
}

h2~p {
  color: #000000;
  font-size: 17px;
}

.login-footer {
  justify-content: center;
}

.login-footer a {
  color: #fff;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
}

.login-footer a:hover {
  text-decoration: underline;
}

.login-btn button {
  background: rgba(var(--vs-primary), 1) !important;
}

.vs-button-primary.vs-button-filled:hover {
  box-shadow: 0 8px 25px -8px rgba(var(--vs-primary), 1);
}

/* Responsive */
@media only screen and (max-width: 600px) {
  .login-footer {
    display: grid;
  }
}

.position {
  position: absolute;
  top: 235px;
  right: 29px;
}

@media only screen and (max-width: 1043px) {
  .position {
    position: absolute;
    top: 249px;
    right: 29px;
  }
}

@media only screen and (max-width: 992px) {
  .position {
    position: absolute;
    top: 235px;
    right: 29px;
  }
}
</style>
